import { gql } from "@apollo/client";

import complianceProgramCalibrationGroupFragment from "./compliance-program-calibration-group-fragment";

export default gql`
  ${complianceProgramCalibrationGroupFragment}
  query getComplianceProgramCalibrationGroups($complianceProgramId: Int!) {
    calibrationGroups(complianceProgramId: $complianceProgramId) {
      edges {
        node {
          ...ComplianceProgramCalibrationGroup
        }
      }
    }
  }
`;
